import { Row } from "./Row";

interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}

export const PersonalInformationSharingAndDisclosures = ({
  onToggle,
  isShow,
}: IProsp) => {
  return (
    <Row
      title="Personal Information Sharing and Disclosures"
      onToggle={onToggle}
      isShow={isShow}
    >
      <div>
        Medcursor may share your personal information with affiliates, vendors,
        or outsource service providers that help us provide products and
        services to our users, or that assist with support functions such as
        marketing, billing, payment card processing, and data analysis. We will
        require any such vendors or service providers to manage your personal
        information with privacy and security safeguards consistent with this
        privacy policy.
        <div className="mt-4">
          For smart devices that interoperate with other devices and systems,
          you will receive notice when information about you might go to third
          parties, and you will have an opportunity to choose not to share the
          information.
        </div>
        <div className="mt-4">
          From time to time, we may be required to respond to a subpoena, court
          order, search warrant, administrative or judicial process, requests by
          law enforcement agencies, or other requests that we must respond to
          under applicable law. We may disclose your personal information in
          response to any of these requirements. Also, we may disclose your
          personal information to preserve the security of our mobile
          applications, website, or social media accounts; resolve dispute;, or
          to assess any possible wrongdoing.
        </div>
        <div className="mt-4">
          We also may share aggregate or anonymous information collected about
          website or social media usage, as long as the information does not
          identify any specific individuals. We may share or transfer personal
          information about you in connection with a merger, acquisition,
          reorganization, or sale of assets of our business, in the event of
          bankruptcy, or during the negotiations leading to such an event. We
          will seek assurances from any buyer that your personal information
          will be used, shared, maintained, and disclosed consistent with the
          terms of this privacy policy.
        </div>
        <div className="mt-4">
          My app will use{" "}
          <a
            className="text-primary font-medium"
            href="https://www.googleapis.com/auth/fitness.blood_glucose.write"
          >
            {" "}
            https://www.googleapis.com/auth/fitness.blood_glucose.write;{" "}
          </a>{" "}
          <a
            className="text-primary font-medium"
            href="https://www.googleapis.com/auth/fitness.blood_pressure.write"
          >
            https://www.googleapis.com/auth/fitness.blood_pressure.write
          </a>{" "}
          in my app so that users can Upload the data of systolic and diastolic
          blood pressure measured by Medcursor blood pressure meter to Google
          Fit through my app. Users can div blood pressure information in
          conjunction with Google Fit. App use and transmission of information
          received from Google API to any other application will comply with the
          Google API service user data policy, including limited use
          requirements.
        </div>
        <div className="mt-4">
          Except as noted above, we will not sell, distribute, transfer, or
          lease your personal information to third parties.
        </div>
      </div>
    </Row>
  );
};
